<template>
    <Table :columns="columns" :data="obj.data.data"></Table>
</template>
<script>
export default {
    name: 'MemberList',
    props: {
        obj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            columns: [
                {
                    title: '用户名',
                    key: 'loginName'
                },
                {
                    title: '部门',
                    key: 'deptName'
                },
                {
                    title: '创建时间',
                    key: 'createTime'
                }
            ],
            data: []
        }
    }
}
</script>
